module.exports = __webpack_public_path__ + "img/bg-Login.2a4466cd.png";